module.exports = __webpack_public_path__ + "files/a6046e017b845781ed01f1398568619f.png";